import { Component, OnInit } from '@angular/core';
import { AuthService } from '../@core/utils';

@Component({
  selector: 'ngx-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent {

  constructor(private authService: AuthService) { }

  login() {
    this.authService.login();
  }

}
